module.exports = __webpack_public_path__ + "img/brand5.50fff5f9.png";